import { TYPE2CLASS } from '../core/icon-class';
import { AlertModalController } from './editor/alert-modal.component';

require('./filter-dimension-node.component.scss');

class FilterDimensionNodeController {
  constructor(
    $scope,
    $http,
    CurrentFilterService,
    PermissionService,
    $rootScope,
    RouterService,
    $modal,
    AggregateDataService,
    CurrentModelService,
    StatusCheckerService,
  ) {
    this.$scope = $scope;
    this.permission = PermissionService;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.TYPE2CLASS = TYPE2CLASS;
    this.$rootScope = $rootScope;
    this.router = RouterService;
    this.$http = $http;
    this.$modal = $modal;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.StatusCheckerService = StatusCheckerService;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  get aggregate() {
    return this.AggregateDataService.aggregate;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get isLoading() {
    return this.AggregateDataService.loading;
  }

  get isLoadingMore() {
    return this.AggregateDataService.loadingMore;
  }

  cells() {
    return this.aggregate && this.aggregate.cells || [];
  }

  hasData() {
    return (this.aggregate &&
      this.aggregate.cells &&
      this.aggregate.cells.length > 0);
  }

  hasCellFilter(cell) {
    let filter = this.model.getCellFilter(this.filterBar.drilldown[0], cell);
    return this.filter.hasFilter(filter);
  }

  getCellFilter(cell) {
    return this.model.getCellFilter(this.filterBar.drilldown[0], cell);
  }

  getCellLabel(cell) {
    return this.model.getCellLabel(this.filterBar.drilldown[0], cell);
  }

  setCellFilter(cell) {
    let filter = this.getCellFilter(cell);
    this.filter.toggleFilter(filter);
    this.currentFilter.rebuildVisibleDimensions();
    this.router.filterChanged();
  }

  hasCard() {
    return [
      'agent_agent',
      'agent_account',
      'agent_application',
      'agent_web',
      'agent_networkconnection',
      'agent_attachedfile',
      'agent_device',
      'agent_dialog',
      'agent_appinstallation',
      'analytics_filter',
    ].some((dim) => this.filterBar.drilldown[0].startsWith(dim));
  }

  openCard(cell) {
    let filter = this.getCellFilter(cell);
    this.router.openCard(filter);
  }

  connectRemote(cell) {
    if (this.menuItem == cell) {
      this.menuItem = null;
      return;
    }
    const hwid = cell['agent_agent.guid'];
    this.$http.get('/staffcop/remote/' + hwid).then((resp) => {
      const users = resp.data;
      if (users.length === 0) {
        this.$modal.open({
          template  : require('./editor/alert-modal.component.html'),
          controller: AlertModalController,
          resolve   : {
            errorStatus: () => gettext('Ошибка'),
            errorText  : () => gettext('Не удалось установить связь с агентом'),
          },
        });
        return;
      }
      if (users.length === -1) {
        this.connectRemoteUser(users[0]);
      }
      else {
        this.remoteUsers = users;
        this.menuItem = cell;
      }
    });
  }

  connectRemoteUser(user) {
    this.menuItem = null;
    if (user.sid)
      this.router.openFrame('/remote/?hwid=' + user.hwid + '/' + user.sid);
    else
      this.router.openFrame('/remote/?hwid=' + user.hwid);
  }

}

export const FilterDimensionNodeComponent = {
  template  : require('./filter-dimension-node.component.html'),
  controller: FilterDimensionNodeController,
};



// WEBPACK FOOTER //
// ./src/filter/filter-dimension-node.component.js